import { render } from "./ProductCriticSavePage.vue?vue&type=template&id=9df3158a"
import script from "./ProductCriticSavePage.vue?vue&type=script&lang=js"
export * from "./ProductCriticSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script